import React, { useEffect, useContext, useState, useCallback, useMemo, useRef } from 'react'
import styled from 'styled-components'
import TripCard from '../TripCard'
import TripsContext from '../../contexts/TripsContext'
import { useReverseGeocode } from '../../hooks/useReverseGeocode'
import { buildReverseGeocodeId } from '../../api/google-integration'
import { DashboardContext } from 'live/context/dashboard'

type IProps = {
    trips: any[]
}

const TripsList = ({ trips = [] }: IProps): JSX.Element => {
    const {
        tripActive,
        reverseGeocoding,
        tripHoverActive,
        setTripHoverActive,
        setTripActive,
        setCenterMap,
        setInfoWindow
    } = useContext(TripsContext)
    const { fillGoogleReverseLatLng } = useReverseGeocode()
    const [tripsLoaded, setTripsLoaded] = useState<any[]>([])

    const executeScroll = id => {
        if (!id) return
        const ele = document.getElementById(id)
        ele.scrollIntoView({ behavior: 'smooth' })
    }

    // useEffect(() => {
    //     if (tripHoverActive?.slide) {
    //         executeScroll(tripHoverActive?.uid)
    //     }
    // }, [tripHoverActive])

    const handleActiveClick = useCallback(
        trip => {
            setInfoWindow(undefined)

            if (tripActive === trip) {
                setTripActive(undefined)
            } else {
                const { lat, lng } = trip
                setCenterMap({ lat, lng })
                setTripActive(trip)
            }
        },
        [tripActive]
    )

    const getAddress = trip => {
        const { lat, lng } = trip
        const key = buildReverseGeocodeId(lat, lng)
        const address = reverseGeocoding[key]?.address

        return address
    }

    useEffect(() => {
        if (trips) {
            const latLngs = trips.map(({ lat, lng }) => ({
                lat,
                lng
            }))

            fillGoogleReverseLatLng(latLngs)
            setTripsLoaded(trips)
        }
    }, [trips])

    return (
        <StyledTrips>
            {tripsLoaded?.map((trip, index) => (
                <div key={index} id={trip.uid}>
                    <TripCard
                        isActive={trip === tripActive}
                        onClick={() => handleActiveClick(trip)}
                        onMouseOver={() => {
                            setTripHoverActive(trip)
                        }}
                        trip={trip}
                        address={getAddress(trip)}
                        driver={trip?.driver}
                    />
                </div>
            ))}
        </StyledTrips>
    )
}

export default React.memo(TripsList)

const StyledTrips = styled.div`
    flex: 1;
`
